import React, { useState } from 'react';
import { 
  FaBoxOpen, 
  FaCheese, 
  FaUsers, 
  FaUserShield, 
  FaSignOutAlt, 
  FaBars, 
  FaTimes 
} from 'react-icons/fa';
import './AdminDashboard.css';

// Acá importarías tus subcomponentes (los armamos después)
import VistaPedidos from '../components/VistaPedidos';
import VistaProductos from '../components/VistaProductos';
import VistaDistribuidores from '../components/VistaDistribuidores';
import VistaUsuarios from '../components/VistaUsuarios';
import VistaStock from '../components/VistaStock';

const AdminDashboard = () => {
  const [vistaActiva, setVistaActiva] = useState('pedidos');
  const [menuAbierto, setMenuAbierto] = useState(false); // Estado para el menú móvil

  // Función para cambiar de vista y cerrar el menú en móviles
  const cambiarVista = (vista) => {
    setVistaActiva(vista);
    setMenuAbierto(false);
  };

  const renderizarContenido = () => {
    switch (vistaActiva) {
      case 'pedidos': return <div><VistaPedidos /></div>;
      case 'productos': return <div><VistaProductos /></div>;
      case 'distribuidores': return <div><VistaDistribuidores /></div>;
      case 'usuarios': return <div><VistaUsuarios /></div>;
      case 'stock': return <div><VistaStock /></div>;
      default: return <div>Seleccione una opción</div>;
    }
  };

  return (
    <div className="admin-container">
      {/* HEADER MÓVIL (Solo se ve en pantallas chicas) */}
      <div className="mobile-header">
        <button className="menu-toggle" onClick={() => setMenuAbierto(true)}>
          <FaBars />
        </button>
        <h2>Páscolo Admin</h2>
      </div>

      {/* OVERLAY: Fondo oscuro para cerrar el menú al hacer clic afuera */}
      {menuAbierto && (
        <div className="sidebar-overlay" onClick={() => setMenuAbierto(false)}></div>
      )}

      {/* BARRA LATERAL (SIDEBAR) */}
      <aside className={`admin-sidebar ${menuAbierto ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2 className="desktop-title">Páscolo Admin</h2>
          {/* Botón cruz para cerrar desde adentro del menú en móvil */}
          <button className="close-menu-btn" onClick={() => setMenuAbierto(false)}>
            <FaTimes />
          </button>
        </div>
        
        <nav className="sidebar-nav">
          <button 
            className={vistaActiva === 'pedidos' ? 'active' : ''} 
            onClick={() => cambiarVista('pedidos')}
          >
            <FaBoxOpen className="nav-icon" /> Pedidos
          </button>
          
          <button 
            className={vistaActiva === 'productos' ? 'active' : ''} 
            onClick={() => cambiarVista('productos')}
          >
            <FaCheese className="nav-icon" /> Productos
          </button>
          
          <button 
            className={vistaActiva === 'distribuidores' ? 'active' : ''} 
            onClick={() => cambiarVista('distribuidores')}
          >
            <FaUsers className="nav-icon" /> Distribuidores
          </button>
          
          <button 
            className={vistaActiva === 'usuarios' ? 'active' : ''} 
            onClick={() => cambiarVista('usuarios')}
          >
            <FaUserShield className="nav-icon" /> Usuarios
          </button>
          
          <button 
            className={vistaActiva === 'stock' ? 'active' : ''} 
            onClick={() => cambiarVista('stock')}
          >
            <FaBoxOpen className="nav-icon" /> Lotes
          </button>
        </nav>
        
        <div className="sidebar-footer">
          <button className="btn-logout" onClick={() => window.location.href = '/'}>
            <FaSignOutAlt className="nav-icon" /> Salir
          </button>
        </div>
      </aside>

      {/* ÁREA DE CONTENIDO PRINCIPAL */}
      <main className="admin-content">
        {renderizarContenido()}
      </main>
    </div>
  );
};

export default AdminDashboard;